<template>
  <div v-show="status != null" :class="{'alert-success': status, 'alert-danger': !status }" role="alert" class=" container alert status-box">
    <button type="button" class="close" @click="resetStatus" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>

    <div class="row">
      <div class="col media">
        <div class="d-flex mr-2 status-icon" >
          <i class="fa" :class="{'fa-check':status, 'fa-exclamation-circle': !status }"></i>
        </div>
        <div class="media-body">
          <h5 class="mt-0" v-if="title">{{title}}</h5>
          <p>{{message}} </p>
        </div>
      </div>
    </div>

  </div>
</template>
<script type="text/babel">
  export default {
    data() {
      return {
      }
    },
    created(){

    },
    destroyed(){
      this.$store.commit('resetStatus');
    },
    computed:{
      status(){
        return this.$store.getters.getStatus;
      },
      title(){
        return this.$store.getters.getTitle;
      },
      message(){
        return this.$store.getters.getMessage;
      }
    },
    methods: {
      resetStatus (){
        this.$store.commit('resetStatus');
      }

    }
  }
</script>
<style scoped>

  .container.status-box{
    padding: 10px 25px;
    font-weight: bold;
  }

  .container.status-box p{
    margin-bottom: 0;
  }
  .container.status-box .status-icon{
    padding-top: 3px;
  }

  .alert-success {
    background-color: #dff0d8;
    border-color: #d0e9c6;
    color: #3c763d;
  }

  .alert-danger {
    background-color: #f2dede;
    border-color: #ebcccc;
    color: #a94442;
  }

   .close {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: .75rem 1.25rem;
    color: inherit;
     z-index: 100;
  }



</style>



// WEBPACK FOOTER //
// Status.vue?a20e5c9c